import {
  GqlModel,
  GqlModelOperator,
  GqlMutationModel,
  GqlQueryModel,
} from "../graphql/graphql.model";
import gql from "graphql-tag";
import {jsonProperty} from "../json.model";

export class DisGqlModel extends GqlQueryModel {
  static mapper: GqlModelOperator<DisGqlModel> =
    GqlModel.buildMapper(DisGqlModel, "dis");

  static formKeys: (keyof DisGqlModel)[] = [
    "id",
    "siteId",
    "deviceId",
    "deviceKey",
    "productNumber",
    "productFamily",
    "installDate",
    "installed",
    "productDescription",
    "solutionsProductNumber",
    "billFromBPIDId",
    "externalId",
    "internalId",
    "currentOnboardingTransactionId",
    "statusKey",
  ];

  static query: any = gql`
    query getDisAvailable($siteId: ID) {
      dis: dis(siteId: $siteId) {
        id
        siteId
        deviceId
        deviceKey
        productNumber
        productFamily
        installDate
        installed
        productDescription
        solutionsProductNumber
        billFromBPIDId
        externalId
        internalId
        currentOnboardingTransactionId
        statusKey
        contractAccountId
      }
    }
  `;

  static getQuery: any = gql`
    query dis($disId: ID) {
      dis: dis(disId: $disId) {
        id
        siteId
        deviceId
        deviceKey
        productNumber
        productFamily
        installDate
        installed
        productDescription
        solutionsProductNumber
        billFromBPIDId
        externalId
        internalId
        currentOnboardingTransactionId
        statusKey
        consolidateInvoice
        contractAccountId
      }
    }
  `;

  @jsonProperty("string") id: string;
  @jsonProperty("string") siteId: string;
  @jsonProperty("string") deviceId: string;
  @jsonProperty("string") deviceKey: string;
  @jsonProperty("string") productNumber: string;
  @jsonProperty("string") productFamily: string;
  @jsonProperty("stringDate") installDate: string;
  @jsonProperty("string") contractAccountId: string;
  @jsonProperty("boolean") installed: boolean;
  @jsonProperty("string") productDescription: string;
  @jsonProperty("string") solutionsProductNumber: string;
  @jsonProperty("string") billFromBPIDId: string;
  @jsonProperty("string") externalId: string;
  @jsonProperty("string") internalId: string;
  @jsonProperty("string") currentOnboardingTransactionId: string;
  @jsonProperty("string") statusKey: string;
  @jsonProperty("boolean") consolidateInvoice: boolean;

  change: boolean = false;

  static variables(disId: string) {
    if (disId) return {disId};
    return {disId: undefined};
  }

  constructor(data: any) {
    super(data);
    data = data || {};

    this.id = data.id;
    this.siteId = data.siteId;
    this.deviceId = data.deviceId;
    this.deviceKey = data.deviceKey;
    this.productNumber = data.productNumber;
    this.productFamily = data.productFamily;
    this.installDate = data.installDate || "";
    this.productDescription = data.productDescription;
    this.solutionsProductNumber = data.solutionsProductNumber || "";
    this.installed = !!data.installed;
    this.billFromBPIDId = data.billFromBPIDId;
    this.externalId = data.externalId || "";
    this.internalId = data.internalId || "";
    this.currentOnboardingTransactionId = data.currentOnboardingTransactionId || "";
    this.statusKey = data.statusKey || "";
    this.contractAccountId = data.contractAccountId || "";
    this.consolidateInvoice = !!data.consolidateInvoice;
  }
}

export class DisInputDataGqlModel extends GqlModel {
  @jsonProperty("string") id: string;
  @jsonProperty("string") siteId: string;
  @jsonProperty("string") deviceId: string;
  @jsonProperty("string") deviceKey: string;
  @jsonProperty("string") productNumber: string;
  @jsonProperty("string") productFamily: string;
  @jsonProperty("stringDate") installDate: string;
  @jsonProperty("boolean") installed: boolean;
  @jsonProperty("string") productDescription: string;
  @jsonProperty("string") solutionsProductNumber: string;
  @jsonProperty("boolean") change: boolean;
  @jsonProperty("string") contractAccountId: string;
  @jsonProperty("string") billFromBPIDId?: string;
  @jsonProperty("string") externalId: string;
  @jsonProperty("string") internalId: string;
  @jsonProperty("string") currentOnboardingTransactionId: string;
  @jsonProperty("string") statusKey: string;
  @jsonProperty("boolean") consolidateInvoice: boolean;
}

export class DisResponseGqlModel extends GqlModel {
  @jsonProperty("boolean") updated: boolean;
  @jsonProperty([DisInputDataGqlModel]) dis: DisInputDataGqlModel[];
  @jsonProperty("string") id: string;
}

export class DisInputGqlModel extends GqlMutationModel {
  static mapper: GqlModelOperator<DisResponseGqlModel> =
    GqlModel.buildMapper(DisResponseGqlModel, "dis");

  static query = gql`
    mutation updateDis($dis: [DisInputType]!) {
      dis: dis(dis: $dis) {
        updated
        dis {
          id
          siteId
          deviceId
          deviceKey
          productNumber
          productFamily
          productDescription
          solutionsProductNumber
          installDate
          contractAccountId
          installed
          productDescription
          billFromBPIDId
        }
      }
    }
  `;

  @jsonProperty([DisInputDataGqlModel]) dis: DisInputDataGqlModel[];
}

export class DisDeleteGqlModel extends GqlMutationModel {
  static mapper: GqlModelOperator<DisResponseGqlModel> =
    GqlModel.buildMapper(DisResponseGqlModel, "dis");

  static query = gql`
    mutation removeDis($disId: ID!) {
      dis: removeDis(disId: $disId) {
        updated
        id
      }
    }
  `;

  @jsonProperty("string") disId: string;
}
